export enum WatchlistDetailNoteType {
    Loan = 1,
    LoanProperty = 2,
    Entity = 3,
}
